import axios from '@/plugins/axios'

const BASE = 'consulta-pf'

export async function consultarPorCpf(cpf) {
  const { data } = await axios.get(`${BASE}/cpf/${encodeURIComponent(cpf)}`)
  return data
}

export async function consultarPorEmail(body) {
  const { data } = await axios.post(`${BASE}/email`, body)
  return data
}

export async function consultarPorPlaca(body) {
  const { data } = await axios.post(`${BASE}/placa`, body)
  return data
}

export async function consultarPorCep(body) {
  const { data } = await axios.post(`${BASE}/cep`, body)
  return data
}

export async function consultarPorNomeMae(body) {
  const { data } = await axios.post(`${BASE}/nome-mae`, body)
  return data
}

export async function consultarPorNome(body) {
  const { data } = await axios.post(`${BASE}/nome`, body)
  return data
}

export async function consultarPorTelefone(body) {
  const { data } = await axios.post(`${BASE}/telefone`, body)
  return data
}
